"use client"
import React, { Fragment, useEffect, useState } from 'react';
import { baseURL, sistemaURL } from '../url.js';
import '../../css/Components/ProductsPage/ProductsPage.css';
import 'react-toastify/dist/ReactToastify.css';
import ProductosLoading from '../ProductosLoading/ProductosLoading';
import { Link as Anchor, useParams } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import Cart from '../Cart/Cart';
import moneda from '../moneda.js';
import ReactPaginate from 'react-paginate';

export default function CategoriasPage() {
    const { nombreCategoria } = useParams();
    const [productos, setProductos] = useState([]);
    const [categorias, setCategorias] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchText, setSearchText] = useState('');
    const [precioMinimo, setPrecioMinimo] = useState(0);
    const [precioMaximo, setPrecioMaximo] = useState(0);
    const [precioActual, setPrecioActual] = useState(0);

    useEffect(() => {
        cargarProductos();
        cargarCategorias();
    }, []);
    const cargarCategorias = () => {
        fetch(`${sistemaURL}/web/getFamiliasHabilitadas`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                if (data) {
                    setCategorias(data);
                }
            })
            .catch(error => console.error('Error al cargar productos:', error));
    }
    const cargarProductos = () => {
        fetch(`${sistemaURL}/web/getArticulosPorFamilia?familia=${nombreCategoria}`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                if (data) {
                    setProductos(data);
                    cargarBotones(data.length)
                }
                const maxPrecio = calcularPrecioMaximo(data);
                setPrecioMaximo(maxPrecio);
                setPrecioActual(maxPrecio);
                setLoading(false);
            })
            .catch(error => console.error('Error al cargar productos:', error));
    };
    const calcularPrecioMaximo = (productos) => {
        return Math.max(...productos.map(producto => producto.precio_unitario_soles));
    };

    const obtenerImagen = (item) => {
        return `${sistemaURL}assets/images/imagenesArticulos/${item.imagen || "sinimagen.jpg"}`
    };

    const handleSearchInputChange = (event) => { setSearchText(event.target.value); };

    const handlePrecioChange = (event) => {
        const precio = parseFloat(event.target.value);
        setPrecioActual(precio);
    };
    const filterProductos = (producto) => {
        const searchTextMatch = searchText === '' || producto.nombre.toLowerCase().includes(searchText.toLowerCase());
        const precioMatch = producto.precio_unitario_soles >= precioMinimo && producto.precio_unitario_soles <= precioActual;
        /*const itemMatches = selectedItems?.length === 0 || selectedItems.some(item => {
            return producto.item1 === item ||
                producto.item2 === item ||
                producto.item3 === item ||
                producto.item4 === item ||
                producto.item5 === item ||
                producto.item6 === item ||
                producto.item7 === item ||
                producto.item8 === item ||
                producto.item9 === item ||
                producto.item10 === item;
        });*/
        return searchTextMatch && precioMatch;
    };
    const productosFiltrados = productos.filter(filterProductos)
    useEffect(() => {
        cargarBotones(productosFiltrados.length)
    }, [productosFiltrados]);

    //ordenando articulos 
    const [ordenamiento, setOrdenamiento] = useState("nombreAZ")
    const manejaOrdenamiento = (e, campo, condicion) => {
        setOrdenamiento(e.target.value)
        productos.sort((a, b) => {
            // let first = campo == "precio_venta_final" ? parseFloat(a[campo]) : (a[campo] || "").toLowerCase()
            // let second = campo == "precio_venta_final" ? parseFloat(b[campo]) : (b[campo] || "").toLowerCase()
            let first = campo == "precio_unitario_soles" ? parseFloat(a[campo]) : (a[campo] || "").toLowerCase()
            let second = campo == "precio_unitario_soles" ? parseFloat(b[campo]) : (b[campo] || "").toLowerCase()
            return first > second ? condicion == "desc" ? -1 : 1 : condicion == "desc" ? 1 : -1
        })
    }
    //paginanacion
    const [cantidad_maxima_mostrar, setCantidadMaximaMostrar] = useState(12)
    const [pagina_actual, setPaginaActual] = useState(1)
    const [botones_disponibles, setBotonesDisponibles] = useState([])
    const cargarBotones = (longitud_articulos = 0) => {
        setBotonesDisponibles(parseInt(longitud_articulos / cantidad_maxima_mostrar) + 1)
    }
    const manejadorCambio = (event) => {
        //const newOffset = event.selected * cantidad_maxima_mostrar % productos.length;
        //console.log(`User requested page number ${event.selected}, which is offset ${newOffset}`);
        setPaginaActual(event.selected + 1);
    };
    return (
        <div className='ProductsContainPage'>
            <Cart />

            {productos?.length > 0 && (
                <>
                    <div className='filtrosPage'>
                        <div className='searchInput'>
                            {productos?.length > 0 &&
                                <fieldset className="inputSearch">
                                    <FontAwesomeIcon icon={faSearch} className="search-icon" />
                                    <input
                                        type="text"
                                        placeholder="Buscar..."
                                        value={searchText}
                                        onChange={handleSearchInputChange}
                                        className='input'
                                    />
                                </fieldset>
                            }
                        </div>
                        <div className='inputsGrap'>
                            <li className="active sin-puntos" >
                                <h4> Ordenar Por</h4>
                                <div className="form-check fs-2">
                                    <input className="form-check-input" type="radio" name="ordenamiento"
                                        checked={ordenamiento === 'nombreAZ'} value="nombreAZ" onChange={(e) => manejaOrdenamiento(e, 'nombre', 'asc')} />
                                    <label className="form-check-label" htmlFor="flexRadioDefault1" >
                                        Por Nombre [A-Z]
                                    </label>
                                </div>
                                <div className="form-check fs-2">
                                    <input className="form-check-input" type="radio" name="ordenamiento"
                                        checked={ordenamiento === 'PrecioZA'} value="PrecioZA" onChange={(e) => manejaOrdenamiento(e, 'precio_unitario_soles', 'desc')} />
                                    <label className="form-check-label" htmlFor="flexRadioDefault2" >
                                        Por Precio [Mayor-Menor]
                                    </label>
                                </div>
                                <div className="form-check fs-2">
                                    <input className="form-check-input" type="radio" name="ordenamiento"
                                        checked={ordenamiento === 'PrecioAZ'} value="PrecioAZ" onChange={(e) => manejaOrdenamiento(e, 'precio_unitario_soles', 'asc')} />
                                    <label className="form-check-label" htmlFor="flexRadioDefault2" >
                                        Por Precio [Menor-Mayor]
                                    </label>
                                </div>
                            </li>

                        </div>

                        <div className='range'>
                            <h5>Límite de Precio</h5>
                            <input type="range" min={precioMinimo} max={precioMaximo} value={precioActual} onChange={handlePrecioChange} />
                            <div>{moneda} {precioActual.toLocaleString()}</div>
                        </div>
                        <hr />
                        <h4>Buscar Otra Categoría</h4>

                        <select
                            onChange={(e) => {
                                window.location.href = `/categoria/${e.target.value}`
                            }}
                        >
                            <option value="">Buscar...</option>
                            {categorias.map(categoria => (
                                <option key={categoria.id} value={categoria.nombre}>
                                    {categoria.nombre}
                                </option>
                            ))}
                        </select>
                    </div>
                </>

            )}
            <div>
                {loading ? (
                    <ProductosLoading />
                ) : (
                    <div>
                        <h2 style={{ textAlign: "center" }}>{nombreCategoria}</h2>
                        <div className='ProductsGrap'>
                            {productosFiltrados.map((item, key) => (
                                <Fragment key={key}>
                                    {key >= (cantidad_maxima_mostrar * (pagina_actual - 1)) && key <= ((pagina_actual * cantidad_maxima_mostrar) - 1) &&
                                        <Anchor className='cardProdcutmasVendido' key={item.id} to={`/producto/${item.id}/${item.nombre.replace(/\s+/g, '-')}`}>
                                            <img src={obtenerImagen(item)} alt="imagen" />
                                            {item.masVendido === 'si' && <h6 className='masVendido'>Más Vendido.</h6>}
                                            <div className='cardText'>
                                                <h4>{item.nombre}</h4>
                                                <span >
                                                    {item.nombre_marca}
                                                </span>
                                                <div className='deFLexPrice'>
                                                    <h5> {moneda} {String(item?.precio_unitario_soles)?.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</h5>
                                                    {/* {item.precioAnterior >= 1 && item.precioAnterior !== undefined && (
                                                    <h5 className='precioTachado'>{moneda} {`${item?.precioAnterior}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</h5>
                                                )} */}
                                                </div>
                                            </div>
                                        </Anchor>
                                    }
                                </Fragment>
                            ))}
                        </div>
                        < br />
                        {productosFiltrados.length > 0 ?
                            <center>
                                <ul className="pagination" role="menubar" aria-label="Pagination">
                                    <ReactPaginate
                                        nextLabel="Siguiente"
                                        onPageChange={manejadorCambio}
                                        pageRangeDisplayed={3}
                                        marginPagesDisplayed={2}
                                        pageCount={Math.ceil(botones_disponibles)}
                                        previousLabel="Anterior"
                                        pageClassName="sin-puntos"
                                        pageLinkClassName="sin-puntos page-link"
                                        previousClassName=" sin-puntos page-item"
                                        previousLinkClassName="page-link"
                                        nextClassName="sin-puntos"
                                        nextLinkClassName="page-link"
                                        breakLabel="..."
                                        breakClassName="sin-puntos"
                                        breakLinkClassName="page-link"
                                        containerClassName="pagination d-flex justify-content-center"
                                        activeClassName="active current"
                                        renderOnZeroPageCount={null}
                                    />
                                </ul>
                            </center>
                            : ""}
                    </div>
                )}
            </div>
        </div >
    );
}
